// 赛事中心api
import request from "@/config/_request";
import qs from "qs";

/**
 * 新赛考中心-题库中心 教师端 查询题库来源列表
 * @returns 
 */
export function api_getBankSourceListWithoutPageForNew(params) {
    return request({
        url: "/api/exam/getBankSourceListWithoutPageForNew",
        params,
        method: "get",
    });
}
/**
 * 新赛考中心-题库中心 教师端 查询题库来源分项列表
 * @returns 
 */
export function api_getTestQuestionBankSourceTagListWithoutPage(params) {
    return request({
        url: "/api/exam/getTestQuestionBankSourceTagListWithoutPage",
        params,
        method: "get",
    });
}
/**
 * 新赛考中心-题库中心 阶段测评 教师端 查询校区题库
 * @returns 
 */
export function api_getSchoolQuestionBankList(params) {
    return request({
        url: "/api/exam/get/school/question/bank/list",
        params,
        method: "get",
    });
}

/**
 * 
 * @param {exam_id:string} 考试ID 必填 
 * @param {post_state:string} 考试状态 必填 
 * @returns 
 */
export function api_editExamPostState(params) {
    return request({
        url: "/api/exam/editExamPostState",
        data: qs.stringify(params),
        method: "post",
    });
}

/**
 * 新赛考中心-题库中心 获取校区轮播图
 * @returns 
 */
export function api_getSchoolBannerList(params) {
    return request({
        url: "/api/get/school/banner/list",
        params,
        method: "get",
    });
}
/**
 * 新赛考中心-题库中心 获得题库来源详细信息
 * @returns 
 */
export function api_getBankSourceInfo(params) {
    return request({
        url: "/api/exam/getBankSourceInfo",
        params,
        method: "get",
    });
}